import { Typography,IconButton, Box, Paper, Chip } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import "../modal/modal.css";

export default function ThirdPartyApiInfo({ dataArr, onClose }) 
{
    if (!dataArr) return null;

    const AUTH_KEY = "RgUkXp2s5v8y5B8E7H1MbQeThVmYq3t6";
    const API_PATH = "https://api.cashi.in/sapi/tp/cashi-sale";

    const payload = { mobile: "XXXXXXXXXX", name: "", pay_type: "CASH", amount: "100.00" };

    const headers = {Authorization: AUTH_KEY,calling_source: "Android",calling_app: "Cashi",app_version: "1","x-api-key": dataArr.encrypt_store_id || "",
            "Content-Type": "application/json",};

    const output = {"status": "200","status_message": "Success","data": {"success": {"order_amount": "100.00","redeem_amount": "23.00","payment_amount": "77.00"}}};

    const copyText = (txt) => navigator.clipboard.writeText(txt);

    return (
    <div className="modal-overlay">
    <div className="modal-container" style={{ maxWidth: "600px" }}>

        {/* HEADER */}
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
        <Typography variant="h6">Third Party API</Typography>
        <span className="closeButtonStyles" onClick={onClose}>✕</span>
        </Box>

        {/* API Endpoint */}
        <Paper sx={{ p: 2, mb: 2, backgroundColor: "#f3f6f9" }} elevation={1}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
            <Chip label="POST" color="primary" size="small" sx={{ mr: 1 }} />
            <Typography variant="subtitle1">{API_PATH}</Typography>
            <IconButton size="small" sx={{ ml: "auto" }} onClick={() => copyText(API_PATH)}><ContentCopyIcon fontSize="small" /></IconButton>
          </Box>
        </Paper>

        {/* Headers */}
        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>Headers 
            <IconButton size="small" onClick={() => copyText(JSON.stringify(headers, null, 2))} sx={{ mt: 1 }}><ContentCopyIcon fontSize="small" /></IconButton>
        </Typography>

        <Paper sx={{ p: 2, mb: 2, maxHeight: 220, overflow: "auto", backgroundColor: "#f7f7f7" }} elevation={1}>
            <pre>{JSON.stringify(headers, null, 2)}</pre>
        </Paper>

        {/* Payload */}
        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>Payload 
                <IconButton size="small" onClick={() => copyText(JSON.stringify(payload, null, 2))} sx={{ mt: 1 }}><ContentCopyIcon fontSize="small" /></IconButton>
        </Typography>
        <Paper sx={{ p: 2, mb: 2, maxHeight: 220, overflow: "auto", backgroundColor: "#f7f7f7" }} elevation={1}>
            <pre>{JSON.stringify(payload, null, 2)}</pre>
        </Paper>

        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>Response</Typography>
        <Paper sx={{ p: 2, mb: 2, maxHeight: 220, overflow: "auto", backgroundColor: "#f7f7f7" }} elevation={1}>
            <pre>{JSON.stringify(output, null, 2)}</pre>
        </Paper>

        {/* FOOTER */}
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <button onClick={onClose} className="btn-group btn-confirm m-1">Close</button>
        </Box>
        
      </div>
    </div>
  );
}
